import { mapProductPrice, RawProductPrice } from '~/Api/Product';
import Price from '~/utils/Price/Price';

import ProductComputedPrice from './ProductComputedPrice';
import ReferencePrice from './ReferencePrice';

interface RawComputedPrice {
	currency: string;
	description: string;
	selected: boolean;
	type: string;
	value: string;
}

export interface RawReferencePrice {
	sourcePrice: RawProductPrice;
	calculatedPrice: RawComputedPrice;
}

export default function mapReferencePrice(referencePrice: RawReferencePrice): ReferencePrice {
	return new ReferencePrice(
		mapProductPrice(referencePrice.sourcePrice),
		new ProductComputedPrice(
			referencePrice.calculatedPrice.type,
			new Price(referencePrice.calculatedPrice.value, referencePrice.calculatedPrice.currency),
			referencePrice.calculatedPrice.description,
			referencePrice.calculatedPrice.selected
		)
	);
}
